"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

var _zipWith = _interopRequireDefault(require("lodash/zipWith"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DATA_TOP_PADDING = 75;
var DATA_TOP_PADDING_MINIMAL = 45;
var DATA_BOTTOM_PADDING = 25;
var DATA_LEFT_PADDING = 15;
var BAR_HEIGHT = 6;
var BAR_GAP = 30;
var BAR_TEXT_WIDTH_NORMAL = 30;
var BAR_TEXT_WIDTH_LARGE = 50;
var DESCRIPTION_CIRCLE_OUTER_RADIUS = 5; // the exact upper limit is not part of the interval, hence the 101 at the end

var PARTICIPATION_BREAKPOINTS = [{
  label: 'Low',
  description: '(0-29%)',
  interval: [0, 30],
  innerRadius: 4
}, {
  label: 'Good',
  description: '(30-59%)',
  interval: [30, 60],
  innerRadius: 3
}, {
  label: 'High',
  description: '(60+%)',
  interval: [60, 101],
  innerRadius: 0
}];

var BarChart = /*#__PURE__*/function (_Component) {
  _inherits(BarChart, _Component);

  var _super = _createSuper(BarChart);

  function BarChart() {
    var _this;

    _classCallCheck(this, BarChart);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderDescription", function (_ref, height) {
      var value = _ref.value;

      // decide which description is the right fit
      var _PARTICIPATION_BREAKP = PARTICIPATION_BREAKPOINTS.find(function (_ref2) {
        var _ref2$interval = _slicedToArray(_ref2.interval, 2),
            lower = _ref2$interval[0],
            upper = _ref2$interval[1];

        return lower <= value && value < upper;
      }),
          innerRadius = _PARTICIPATION_BREAKP.innerRadius,
          label = _PARTICIPATION_BREAKP.label;

      return /*#__PURE__*/_react.default.createElement("g", {
        key: "grid",
        transform: "translate(20, ".concat(height, ")")
      }, /*#__PURE__*/_react.default.createElement("circle", {
        cy: "-8",
        r: DESCRIPTION_CIRCLE_OUTER_RADIUS,
        fill: "#f4bf6c"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cy: "-8",
        r: innerRadius,
        fill: "white"
      }), /*#__PURE__*/_react.default.createElement("text", {
        x: "15",
        dy: "-3",
        fontFamily: "Raleway, sans-serif",
        fontSize: "13px",
        fill: "#3d4640",
        fontWeight: "700"
      }, label));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGrid", function (height, width, scaleX) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          minimal = _this$props.minimal,
          inverted = _this$props.inverted;
      var simple = minimal || _this.props.simple; //const descriptionColor = this.props.primary ? theme.main.primary : theme.one[0] // TODO: Discuss with Oliver whether we really need this complexity

      var headingColor = inverted ? theme.inverted.one[0] : theme.one[0];
      var subHeadingColor = inverted ? theme.inverted.one[2] : theme.one[2];
      var pointColor = inverted ? theme.inverted.one[0] : theme.one[0];
      var borderColor = inverted ? theme.one[1] : theme.one[1]; // scale breakpoints and add them to the constant list

      var offsets = [0, scaleX(30) + DATA_LEFT_PADDING, scaleX(60) + DATA_LEFT_PADDING];
      var gridBreakpoints = (0, _zipWith.default)(PARTICIPATION_BREAKPOINTS, offsets, function (breakpoints, offset) {
        return _objectSpread(_objectSpread({}, breakpoints), {}, {
          offset: offset
        });
      }); // simple charts have their percentage descriptions moved below the text

      var descriptionProps = simple ? {
        x: 40,
        dy: 20
      } : {};
      var markers = gridBreakpoints.map(function (_ref3) {
        var label = _ref3.label,
            offset = _ref3.offset,
            description = _ref3.description,
            innerRadius = _ref3.innerRadius;
        return /*#__PURE__*/_react.default.createElement("g", {
          key: label,
          transform: "translate(".concat(offset, ", 0)")
        }, /*#__PURE__*/_react.default.createElement("rect", {
          fill: borderColor,
          x: "-4",
          width: "9",
          height: "1"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          fill: borderColor,
          width: "1",
          height: height
        }), /*#__PURE__*/_react.default.createElement("mask", {
          id: 'marker-clip-' + label
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "20",
          cy: "15",
          r: DESCRIPTION_CIRCLE_OUTER_RADIUS,
          fill: "white"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "20",
          cy: "15",
          r: innerRadius,
          fill: "black"
        })), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "20",
          cy: "15",
          r: DESCRIPTION_CIRCLE_OUTER_RADIUS,
          fill: pointColor,
          mask: "url(#".concat('marker-clip-' + label, ")")
        }), /*#__PURE__*/_react.default.createElement("text", {
          x: "40",
          y: "20",
          alignmentBaseline: "hanging"
        }, /*#__PURE__*/_react.default.createElement("tspan", {
          fontFamily: "Raleway, sans-serif",
          fontSize: "13px",
          fill: headingColor,
          fontWeight: "700"
        }, label), "\xA0\xA0\xA0", !minimal ? /*#__PURE__*/_react.default.createElement("tspan", _extends({}, descriptionProps, {
          fontFamily: "LL Circular Book Web, sans-serif",
          fontSize: "12px",
          fill: subHeadingColor,
          fontWeight: "500"
        }), description) : null));
      });
      return /*#__PURE__*/_react.default.createElement("g", {
        key: "grid"
      }, markers, /*#__PURE__*/_react.default.createElement("g", {
        key: "bottom",
        transform: "translate(0, ".concat(height, ")")
      }, /*#__PURE__*/_react.default.createElement("rect", {
        fill: borderColor,
        width: width,
        height: "1"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBar", function (_ref4) {
      var fill = _ref4.fill,
          x1 = _ref4.x1,
          x2 = _ref4.x2,
          y = _ref4.y,
          value = _ref4.value,
          key = _ref4.key,
          xmax = _ref4.xmax;
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          inverted = _this$props2.inverted;
      var backgroundColor = inverted ? theme.inverted.two[0] : theme.inverted.one[0];
      return /*#__PURE__*/_react.default.createElement("g", {
        key: key,
        transform: "translate(".concat(DATA_LEFT_PADDING, ", 0)")
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: x1,
        y: y,
        width: xmax,
        height: BAR_HEIGHT,
        rx: "4",
        fill: backgroundColor
      }), /*#__PURE__*/_react.default.createElement("rect", {
        x: x1,
        y: y,
        width: x2 - x1,
        height: BAR_HEIGHT,
        rx: "4",
        fill: fill
      }), _this.renderBarText(x1, x2, y, value));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBarText", function (x1, x2, y, value) {
      var _this$props3 = _this.props,
          simple = _this$props3.simple,
          minimal = _this$props3.minimal,
          highlight = _this$props3.highlight; // simplified chart does not display any text above the bar

      if (simple || minimal) return null; // regular chart renders normal size percentages

      if (!highlight) {
        return /*#__PURE__*/_react.default.createElement("text", {
          x: x2,
          y: y - BAR_HEIGHT,
          fill: "#3d4640",
          fontFamily: "LL Circular Black Web, sans-serif",
          fontWeight: "900",
          fontSize: "15px",
          textAnchor: x2 - x1 < BAR_TEXT_WIDTH_NORMAL ? 'start' : 'end'
        }, value, "%");
      } // if highlighted render large signs


      return /*#__PURE__*/_react.default.createElement("text", {
        x: x2,
        y: y - 20,
        fill: "#3d4640",
        fontFamily: "LL Circular Book Web, sans-serif",
        fontWeight: "500",
        fontSize: "34px",
        textAnchor: x2 - x1 < BAR_TEXT_WIDTH_LARGE ? 'start' : 'end'
      }, value, /*#__PURE__*/_react.default.createElement("tspan", {
        fontSize: "18px"
      }, "%"));
    });

    return _this;
  }

  _createClass(BarChart, [{
    key: "renderChartDetails",
    value: function renderChartDetails(width) {
      var _this2 = this;

      var _this$props4 = this.props,
          data = _this$props4.data,
          highlight = _this$props4.highlight,
          minimal = _this$props4.minimal;
      var ids = data.map(function (x) {
        return x.id;
      }); // height of bars and gaps in between. last bar height is excluded

      var yAxisHeight = (data.length - 1) * (BAR_HEIGHT + BAR_GAP); // width of the maximum bar

      var xAxisWidth = width - DATA_LEFT_PADDING; // height of the grid. width is given by function input

      var dataTopPadding = minimal ? DATA_TOP_PADDING_MINIMAL : DATA_TOP_PADDING;
      var height = yAxisHeight + BAR_HEIGHT + dataTopPadding + DATA_BOTTOM_PADDING; // vertical draw scale (id -> y-coordinate)

      var scaleY = d3.scalePoint().range([dataTopPadding, dataTopPadding + yAxisHeight]).domain(ids); // horizontal draw scale 1 (value -> x-coordinate)

      var scaleX = d3.scaleLinear().range([0, xAxisWidth]).domain([0, 100]).nice(10); // render bars + bar background + bar text

      var originPx = scaleX(d3.min(scaleX.range()));
      var bars = data.map(function (_ref5) {
        var value = _ref5.value,
            id = _ref5.id,
            fill = _ref5.fill;
        var attrs = {
          key: id,
          value: value,
          x1: originPx,
          x2: scaleX(value),
          y: scaleY(id),
          xmax: xAxisWidth,
          fill: fill
        };
        return _this2.renderBar(attrs);
      }); // compose SVG element

      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height
      }, highlight // describe first element only
      ? this.renderDescription(data[0], height) // one is subtracted from the grid height
      // in order to draw the bottom axis inside the SVG element
      : this.renderGrid(height - 1, xAxisWidth + DATA_LEFT_PADDING, scaleX), bars);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderChartDetails(this.props.width);
    }
    /*
      FIXME: Move this wrapper out of data-viz entirely
      render() {
        if (!this.props.data) return null
        return (
          <div>
            <ContainerDimensions>
              {({ width }) => this.renderChartDetails(width)}
            </ContainerDimensions>
          </div>
        )
      }
     */

  }]);

  return BarChart;
}(_react.Component);

BarChart.propTypes = {
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    ids: _propTypes.default.string,
    fill: _propTypes.default.string,
    values: _propTypes.default.number
  })),
  minimal: _propTypes.default.bool,
  simple: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  highlight: _propTypes.default.bool
};
BarChart.defaultProps = {
  minimal: false,
  simple: false,
  inverted: false,
  highlight: false
};

var _default = (0, _styledComponents.withTheme)(BarChart);

exports.default = _default;
//# sourceMappingURL=BarChart.js.map